import { useTranslation } from 'react-i18next'
import { formatPrice } from 'utils/utils'
import { ReactComponent as CloseIcon } from '../../../icons/assets/X.svg'
import { useGroupCheckoutPricing } from '../hooks/useGroupCheckoutPricing'
import Skeleton from 'components/Skeleton/Skeleton'
import * as S from './HeaderSegment.styles'

type HeaderSegmentProps = {
  onClose: () => void
}

function HeaderSegment({ onClose }: HeaderSegmentProps) {
  const { t } = useTranslation()
  const groupPricing = useGroupCheckoutPricing()
  const totalCost = groupPricing.data?.productTotalAfterDiscount
  const totalBeforeDiscount = groupPricing.data?.productTotalBeforeDiscount
  const currency = groupPricing.data?.currency

  const isLoading = groupPricing.isLoading
  const hasPrice =
    !isLoading && typeof totalCost === 'number' && typeof currency === 'string'
  const hasDiscount =
    hasPrice &&
    typeof totalBeforeDiscount === 'number' &&
    totalBeforeDiscount > totalCost

  return (
    <S.Header>
      <S.TitleRow>
        <span data-testid="cart-title">{t('order.cart_title')}</span>
        {isLoading ? (
          <>
            <span>·</span>
            <Skeleton width={60} aria-label="Loading price" role="status" />
          </>
        ) : (
          hasPrice && (
            <>
              <span>·</span>
              <span data-testid="cart-header-total-price">
                {formatPrice(totalCost, currency)}
              </span>
              {hasDiscount && (
                <S.OriginalPrice data-testid="cart-header-original-price">
                  {formatPrice(totalBeforeDiscount, currency)}
                </S.OriginalPrice>
              )}
            </>
          )
        )}
      </S.TitleRow>
      <S.CloseButton onClick={onClose} data-testid="cart-close-button">
        <CloseIcon />
      </S.CloseButton>
    </S.Header>
  )
}

export default HeaderSegment
